import { render, staticRenderFns } from "./loginBind.vue?vue&type=template&id=71213c68&scoped=true&"
import script from "./loginBind.vue?vue&type=script&lang=js&"
export * from "./loginBind.vue?vue&type=script&lang=js&"
import style0 from "./loginBind.vue?vue&type=style&index=0&id=71213c68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71213c68",
  null
  
)

export default component.exports